<template>
    <div>
        <loader v-if="isLoading" />
        <alert-container :messages="msgs" />

        <div class="listing-header mb-4">
            <div class="title-breadcrumb"></div>
            <div class="header-buttons" >
                <button
                    v-if="
                        (!integracao && !isUpdate && permissao.create) ||
                        (!integracao && isUpdate && permissao.update)
                    "
                    @click="save"
                    :disabled="isSaving||(tabPrecoPai ? idInativo === tabPrecoPai.id : false)"
                    class="save-btn"
                    type="button"
                >
                    {{ $t("salvar") }}
                    <button-loader :isSaving="isSaving" />
                </button>
            </div>
        </div>

        <div class="page-container form-columns-fit">
            <div class="columns is-flex-wrap">
                <div class="column is-2">
                    <v-input
                        :id="generateId(7)"
                        ref="idErpInput"
                        v-model="tabelaPreco.idtabprecoerp"
                        placeholder="placeholder-preencha"
                        :maxlength="30"
                        title="codigo"
                        uppercase
                        required
                        :invalid="!tabelaPreco.idtabprecoerp"
                        tooltipLabel="cod-ref"
                        :disabled="cantEdit"
                    />
                </div>
                <div class="column is-6">
                    <v-input
                        :id="generateId(1)"
                        ref="descricaoInput"
                        v-model="tabelaPreco.descricao"
                        placeholder="placeholder-preencha"
                        :maxlength="50"
                        title="descricao"
                        msg="msg-campo-obrigatorio"
                        :invalid="!tabelaPreco.descricao"
                        uppercase
                        :required="true"
                        tooltipLabel="info-descricao-tabpreco"
                        :disabled="cantEdit"
                    />
                </div>
                <div class="column is-4">
                    <verified-date-picker
                        :id="generateId(2)"
                        v-model="date"
                        placeholder="selecione-uma-data"
                        title="data-validade"
                        :subtractDateYears="0"
                        :addDateYears="2"
                        :yearsRange="[-2, 10]"
                        :inForm="true"
                        :showToday="false"
                        :showClean="false"
                        :required="true"
                        :invalid="!date"
                        tooltipLabel="info-data-validade"
                        :disabled="cantEdit"
                    />
                </div>
                <div class="column is-6">
                    <vss-select
                        :id="generateId(3)"
                        ref="empresaSelect"
                        :searchable="false"
                        :options="empresas"
                        v-model="empresa"
                        class="no-clear"
                        :required="true"
                        title="empresa"
                        :invalid="!empresa"
                        :onBlurFunction="recarregarTabPreco"
                        tooltipLabel="info-empresa"
                        :disabled="cantEdit"
                    />
                </div>
                <div class="column is-6">
                    <vss-select
                        :id="generateId(4)"
                        ref="moedaSelect"
                        :searchable="false"
                        :options="moedas"
                        v-model="moeda"
                        class="no-clear"
                        :required="true"
                        title="campo-moeda"
                        :invalid="!moeda"
                        tooltipLabel="info-moeda"
                        :disabled="cantEdit"
                    />
                </div>
                <div class="column is-2">
                    <v-input
                        :id="generateId(5)"
                        ref="minimoItensPedidoInput"
                        v-model="tabelaPreco.volumeminimopedido"
                        placeholder="placeholder-preencha"
                        title="volume-minimo-pedido"
                        validchars="0123456789"
                        tooltipLabel="info-volume-minimo-pedido"
                        :disabled="cantEdit"
                    />
                </div>
                <div class="column is-2">
                    <v-input
                        :id="generateId(6)"
                        v-model="tabelaPreco.porcacrescflex"
                        placeholder="placeholder-preencha"
                        :maxlength="3"
                        title="porcentual-desconto-flex"
                        :required="true"
                        ref="porcentualDescontoFlexInput"
                        :invalid="!tabelaPreco.porcacrescflex"
                        msg="msg-campo-obrigatorio"
                        validchars="0123456789"
                        :tooltipMultilined="true"
                        tooltipPosition="is-right"
                        tooltipLabel="info-percentual-desconto-flex"
                        tooltipSize="is-small"
                        :disabled="cantEdit"
                    />
                </div>
                <div class="column is-2">
                    <v-input
                        :id="generateId(8)"
                        v-model="tabelaPreco.descprodutoqtde"
                        placeholder="placeholder-preencha"
                        :maxlength="3"
                        title="desconto-produto"
                        ref="descontoProdutoInput"
                        validchars="0123456789."
                        tooltipLabel="info-desconto-produto"
                        :disabled="cantEdit"
                    />
                </div>
                <div class="column is-6">
                    <vss-select
                        :id="generateId(7)"
                        ref="idTabelaPrecoPai"
                        :options="tabelasPrecoPai"
                        v-model="tabPrecoPai"
                        class="no-clear"
                        :required="true"
                        title="tabela-preco-pai"
                        :invalid="!tabPrecoPai"
                        :tooltipMultilined="true"
                        tooltipPosition="is-right"
                        tooltipLabel="info-tabela-preco-pai"
                        tooltipSize="is-small"
                        :disabled="cantEdit"
                    />
                </div>
                <div class="column is-4">
                    <vss-select
                        :id="generateId(9)"
                        ref="reajusteCifFobSelect"
                        :searchable="false"
                        :options="opcoesReajuste"
                        v-model="opcaoReajuste"
                        class="no-clear"
                        tooltipLabel="info-reajuste-cif-fob"
                        title="reajuste-cif-fob"
                        :disabled="cantEdit"
                    />
                </div>
                <div class="column is-4">
                    <color-picker
                        id="cor"
                        type="text"
                        ref="corInput"
                        :color="tabelaPreco.cor"
                        style="z-index: 1 !important"
                        @colorpicked="colorpicked"
                        tooltipLabel="info-cor"
                        title="selecione-uma-cor"
                        :disabled="cantEdit"
                    />
                </div>
                <div class="column is-4">
                    <vss-select
                        :id="generateId(10)"
                        ref="situacaoSelect"
                        :searchable="false"
                        :options="situacoes"
                        v-model="situacao"
                        class="no-clear"
                        :mlLabels="true"
                        :disabled="tabelaPreco.id == null || cantEdit"
                        title="situacao"
                        tooltipLabel="info-situacao-generica"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import TabPrecoService from "@/services/vendas/tabpreco/TabPrecoService";
import MoedaService from "@/services/vendas/MoedaService";
import TabPrecoValidation from "@/services/validations/vendas/TabPrecoValidation";
import Message from "@/models/Message";
import HideInfo from "@/components/shared/HideInfo";
import { mapState } from "vuex";
import ColorPicker from "@/components/shared/form/ColorPicker";
import AssTabPrecoCliente from "@/services/vendas/cliente/abas/AssTabPrecoClienteService";

export default {
    components: {
        HideInfo,
        ColorPicker,
        AssTabPrecoCliente,
    },
    props: {
        isUpdate: {
            type: Boolean,
            default: false,
        },
        isChanged: {
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            assTabPrecoClienteIntegracao:
                this.$store.state.user.tabelasERPWebServer.includes("ASSTABPRECOCLIENTE"),
            showIcon: true,
            integracao:
                this.$store.state.user.tabelasERPWebServer.includes("TABPRECO"),
            service: new TabPrecoService(this.$http, this.$router),
            serviceMoeda: new MoedaService(this.$http, this.$router),
            serviceAss: new AssTabPrecoCliente(this.$http, this.$router),
            isLoading: false,
            msgs: [],
            isSaving: false,
            validation: null,
            tabelaPreco: {
                id: null,
                idtabprecoerp: null,
                descricao: null,
                datavalidade: null,
                volumeminimopedido: null,
                porcacrescflex: null,
                descprodutoqtde: 0,
                reajusteciffob: null,
                cor: "#D0CFCF",
                situacao: null,
                idempresa: null,
                moeda: null,
                idmoeda: null,
                idtabprecodescontopai: 0,
            },
            situacoes: [
                { label: "inativo", id: 0 },
                { label: "ativo", id: 1 },
            ],
            empresas: [{ id: 0, label: this.$t("todos").toUpperCase() }],
            empresa: { id: 0, label: this.$t("todos").toUpperCase() },
            opcoesReajuste: [
                { label: "Cif", id: 0 },
                { label: "Fob", id: 1 },
            ],
            opcaoReajuste: { label: "Cif", id: 0 },
            situacao: { label: "ativo", id: 1 },
            moedas: [],
            moeda: { id: 0, label: "" },
            date: new Date(this.$moment().add(1, "days")),
            isRedirecting: false,
            permissao: false,
            permissaoVincular: false,
            cantEdit: false,
            // para controlar algumas aÃ§Ãµes atÃ© os dados serem carregados na edição
            isLoadingEdit: false,
            tabelasPrecoPai: null,
            tabPrecoPai: null,
            idInativo: null,
            hoje: new Date(),
            isVenda: this.$route.meta.contexto == "vendas",
        };
    },
    watch: {
        tabelaPreco: {
            deep: true,
            handler: function () {
                if (!this.isLoadingEdit) {
                    this.$emit("isChanged", true);
                }
            },
        },
    },
    created() {
        setTimeout(() => {
            this.$emit("isChanged", false);
        }, 500);
        this.permissao = this.hasPermissionAccess(
            "vendas",
            "vendas",
            "ven-tabelapreco"
        );
        this.validation = new TabPrecoValidation(this.msgs);
        this.permissaoVincular = this.permissao.create && !this.assTabPrecoClienteIntegracao;
        if (
            (!this.isUpdate && !this.permissao.create) ||
            (this.isUpdate && !this.permissao.read)
        ) {
            this.$router.push({
                name: "acesso-nao-permitido",
                params: { tela: "tabelapreco" },
            });
        } else {
            if (this.isUpdate) {
                this.cantEdit = !this.permissao.update || this.integracao;
                this.carregarDados();
            } else {
                this.loadMoedas();
                this.loadEmpresas();
                this.loadTabPreco(0);
            }
        }
    },
    computed: {
        ...mapState(["hide"]),
    },
    methods: {
        loadEmpresas() {
            if (this.$store.state.user.admin) {
                // se for admin, mostra todas as empresas
                this.$store.state.empresas.data.map((e) => {
                    this.empresas.push({ id: e.id, label: e.rsocial });
                });
            } else {
                // se for cliente, mostra todas as empresas relacionadas a ele
                this.$store.state.user.empresas.map((e) => {
                    this.empresas.push({ id: e.id, label: e.rsocial });
                });
            }

            // Carregar empresa
            if (this.tabelaPreco.idempresa) {
                this.empresa = this.empresas.filter((element) => element.id === this.tabelaPreco.idempresa)[0];
            }
        },
        loadMoedas() {
            this.serviceMoeda
                .findAllCombo("")
                .then((body) => {
                    return body.content.map((r) => {
                        return {
                            id: r.idmoeda,
                            label: `${r.simbolomonetario} - ${r.descricao}`,
                        };
                    });
                })
                .then((r) => {
                    this.moedas = Object.assign(r);
                })
                .catch((e) => {
                    console.error("Erro ao carregar moedas: " + e);
                })
                .finally(() => {
                    if (this.isUpdate) {
                        let tempMoeda = this.moedas.filter(
                            (e) => e.id == this.tabelaPreco.idmoeda
                        );
                        this.moeda =
                            tempMoeda.length > 0
                                ? tempMoeda[0]
                                : this.moedas[0];
                    } else {
                        this.moeda = this.moedas[0];
                    }
                });
        },
        // @84570 - Criado método para carregar combo de tabelas de preço
        loadTabPreco(empresaSelecionada, tabprecopai = "0") {
            // @84570 - Caso não tenha empresa selecionado ou seja selecionada todas, será atribuído valor 0, onde fara a pesquisa contabilizando todas as empresas disponíveis
            if(!empresaSelecionada){
                empresaSelecionada = '0'
                for(let empresa of this.empresas){
                    if(empresa.id != 0){
                        empresaSelecionada += `, ${empresa.id}`;
                    }
                }
            } else {
                empresaSelecionada = `0, ${empresaSelecionada}`;
            }
            // @84570 - Caso seja update de uma já existente
            // @84570 - Caso seja uma adição de tabela de preço nova
            let idtabpreco = (this.isUpdate) ? this.$route.params.id : 0; 
            this.service
                .findAllCombo(idtabpreco, empresaSelecionada, tabprecopai)
                .then((body) => {
                    return body.content.map((r) => {
                        if(r.situacao != 0 
                        &&(this.$moment(r.datavalidade).isAfter(this.hoje)
                        ||this.$moment(r.datavalidade).isSame(this.hoje, 'day'))){
                            return {
                                id: r.idtabpreco,
                                label: `${r.idtabprecoerp} - ${r.descricao}`,
                            };   
                        } else {
                            this.idInativo = r.idtabpreco;
                            return {
                                id:r.idtabpreco,
                                label: `${r.idtabprecoerp} - ${r.descricao}`,
                                cor: '#FF0000',
                                icone: 'fas fa-triangle-exclamation'
                            }
                        }
                    });
                })
                .then((r) => {
                    this.tabelasPrecoPai = Object.assign([]);
                    this.tabelasPrecoPai.push({ id: 0, label: this.$t('nenhuma-associacao-generica').toUpperCase() });
                    for(let tabpreco of r){
                        this.tabelasPrecoPai.push(tabpreco)
                    }
                })
                .catch((e) => {
                    console.error("Erro ao carregar tabelas de preço: " + e);
                })
                .finally(() => {
                    if (this.isUpdate) {
                        let tempTab = this.tabelasPrecoPai.filter(
                            (e) => e.id == this.tabelaPreco.idtabprecodescontopai
                        );
                        this.tabPrecoPai =
                            tempTab.length > 0
                                ? tempTab[0]
                                : this.tabelasPrecoPai[0];
                    } else {
                        this.tabPrecoPai = this.tabelasPrecoPai[0];
                    }
                });
        },
        generateId(numberId) {
            return this.$route.name + "-dados-cadastrais-" + numberId;
        },
        infoIsHidden() {
            this.$store.dispatch("infoIsHidden", {
                infoIsHidden: !this.hide.infoIsHidden,
            });
        },
        save() {
            this.tabelaPreco.datavalidade = this.date;
            this.tabelaPreco.idempresa = this.empresa.id;
            this.tabelaPreco.idmoeda = this.moeda.id;

            if (this.validation.validate(this.tabelaPreco, this.$refs)) {
                if (this.tabelaPreco.descprodutoqtde == "") {
                    this.tabelaPreco.descprodutoqtde = 0;
                    this.$refs.descontoProdutoInput.innerValue = 0;
                    
                }

                if (this.tabelaPreco.volumeminimopedido == "") {
                    this.tabelaPreco.volumeminimopedido = 0;
                    this.$refs.minimoItensPedidoInput.innerValue = 0;
                }

                this.tabelaPreco.idtabprecodescontopai = this.tabPrecoPai.id
                if (this.tabelaPreco.idtabprecodescontopai == ""){
                    this.tabelaPreco.idtabprecodescontopai = 0;
                }

                this.isLoading = true;

                let tabelaPrecoTemp = {};

                tabelaPrecoTemp.idtabpreco = this.tabelaPreco.idtabpreco;

                tabelaPrecoTemp.descricao = this.tabelaPreco.descricao;
                tabelaPrecoTemp.datavalidade = this.tabelaPreco.datavalidade;
                tabelaPrecoTemp.idempresa = this.tabelaPreco.idempresa;
                tabelaPrecoTemp.volumeminimopedido = parseInt(
                    this.tabelaPreco.volumeminimopedido
                );
                tabelaPrecoTemp.porcacrescflex = parseInt(
                    this.tabelaPreco.porcacrescflex
                );
                tabelaPrecoTemp.descprodutoqtde = parseFloat(
                    this.tabelaPreco.descprodutoqtde
                );
                tabelaPrecoTemp.idtabprecodescontopai = this.tabelaPreco.idtabprecodescontopai;
                tabelaPrecoTemp.reajusteciffob = this.opcaoReajuste.id;
                tabelaPrecoTemp.cor = this.tabelaPreco.cor;
                tabelaPrecoTemp.situacao = this.situacao.id;
                tabelaPrecoTemp.idmoeda = this.tabelaPreco.idmoeda;
                tabelaPrecoTemp.idtabprecoerp = this.tabelaPreco.idtabprecoerp

                tabelaPrecoTemp = this.mapTosave(tabelaPrecoTemp);
                this.isSaving = true;
                this.service
                    .save(tabelaPrecoTemp)
                    .then((value) => {
                        if (value.status === 500) {
                            let message = value.message;
                            if (message && this.$te(message)) {
                                if (message == "msg-codigo-duplicado-n") {
                                    this.msgs.push(
                                        new Message(
                                            "alert", 
                                            this.$t(message, { n: tabelaPrecoTemp.idtabprecoerp }), 
                                            true, 
                                            false
                                        )
                                    );
                                } else {
                                    this.msgs.push(
                                        new Message("alert", message, true)
                                    );
                                }
                            } else {
                                this.msgs.push(
                                    new Message(
                                        "error",
                                        "msg-problema-realizar-acao",
                                        true
                                    )
                                );
                            }
                        } else if (value.status === 200) {
                            let msg = "tabela-preco-cadastrada-sucesso";
                            if (this.tabelaPreco.idtabpreco != null) {
                                msg = "tabela-preco-editada-sucesso";
                            }
                            this.msgs.push(new Message("success", msg, true));
                            this.$emit("isChanged", false);
                            // @85242
                            if(this.permissaoVincular && !this.isUpdate && this.$route.query.tela == 'ven-cliente-tabela-preco'){
                                this.promptConfirmaVinculo(value.content);
                            }else{
                                this.redirectToPage();
                            }
                        } else {
                            if (this.$te(value.message)) {
                                this.msgs.push(
                                    new Message("alert", value.message, true)
                                );
                            } else {
                                this.msgs.push(
                                    new Message(
                                        "error",
                                        "msg-problema-realizar-acao",
                                        true
                                    )
                                );
                            }
                        }
                    })
                    .catch((e) => {
                        let message = e.body.message;
                        if (message && this.$te(message)) {
                            if (message == "msg-codigo-duplicado-n") {
                                this.msgs.push(
                                    new Message(
                                        "alert", 
                                        this.$t(message, { n: tabelaPrecoTemp.idtabprecoerp }), 
                                        true, 
                                        false
                                    )
                                );
                            } else {
                                this.msgs.push(
                                    new Message("alert", message, true)
                                );
                            }
                        } else {
                            this.msgs.push(
                                new Message(
                                    "error",
                                    "msg-problema-realizar-acao",
                                    true
                                )
                            );
                        }
                    })
                    .finally(() => {
                        this.isSaving = false;
                        this.isLoading = false;
                    });
            } else {
                this.runValidations();
                this.isLoading = false;
            }
        },
         // @85242 
        promptConfirmaVinculo(vinculo){
            this.$root.confirm({
                message: this.$t('deseja-realizar-vinculo'),
                onConfirm: _ => {this.realizarVinculo(vinculo)},
                onCancel: _ => { this.redirectToPage() },
            });
        },
        // @85242
        realizarVinculo(vinculo){
            this.isLoading = true;
            this.isLoadingEdit = true;
            let clienteTabelaPrecoTemp = 
                {
                    tabpreco: this.tabelaPreco,
                    idtabpreco: vinculo.idtabpreco,
                    idcliente: this.$route.query['id'],
                    moeda: this.moeda
                }
            
            this.saveAssTabPreco(clienteTabelaPrecoTemp)
            .then((value) => {
                if(value.message == null){
                    this.$root.showMessage("success", "msg-sucesso-ao-adicionar-associacao");
                    this.redirectToPage();
                }
                else{
                    if (this.$t(value.message)) {
                        this.msgs.push(new Message('alert', value.message, true));
                    } else {
                        this.msgs.push(
                            new Message('error', 'msg-problema-realizar-acao', true)
                        );
                    }
                }
            })
            .catch((e) => {
                this.msgs.push(new Message("alert", "msg-erro-load", true));
            })
            .finally(() => {
                this.isLoading = false;
                this.isLoadingEdit = false;
            });
        },
        saveAssTabPreco(clienteTabelaPreco){
            if(this.isVenda) return this.serviceAss.saveAssVendas(clienteTabelaPreco);
            else return this.serviceAss.saveAssAgro(clienteTabelaPreco);
        },
        recarregarTabPreco(){
            setTimeout(() => {
                this.loadTabPreco(this.empresa.id)
            }, 200)
        },
        carregarDados() {
            this.isLoading = true;
            this.isLoadingEdit = true;
            this.service
                .find(this.$route.params.id)
                .then((value) => {
                    this.tabelaPreco = value.content;
                    this.tabelaPreco.moeda = value.content.idmoeda;
                    this.date = new Date(
                        this.$moment(value.content.datavalidade)
                    );
                    this.situacao = this.situacoes[this.tabelaPreco.situacao];
                    this.opcaoReajuste =
                        this.opcoesReajuste[this.tabelaPreco.reajusteciffob];
                    this.moeda = this.moedas.find(
                        (element) => element.id === this.tabelaPreco.moeda
                    );

                })
                .catch((e) => {
                    console.error(e);
                    this.msgs.push(new Message("error", "msg-erro-load", true));
                })
                .finally((_) => {
                    this.loadEmpresas();
                    this.loadMoedas();
                    this.loadTabPreco(this.tabelaPreco.idempresa, this.tabelaPreco.idtabprecodescontopai);
                    this.isLoading = false;
                    this.isLoadingEdit = false;
                });
        },
        runValidations(focusedOut = false) {
            if (focusedOut) {
                // Utilizado para ativar a validação dos campos ao carregar os dados de alteração
                Object.entries(this.$refs).forEach(([key, value]) => {
                    value.focusedOut = true;
                });
            }
        },

        redirectToPage() {
            this.isRedirecting = true;
            let tempTela = null;
            if (this.$route.query.tela == `${this.$route.query.contexto}-cliente-tabela-preco` || this.$route.query.tela == "ven-cliente-financeiro") {
                tempTela = `${this.$route.query.contexto}-cliente-politica-comercial-edit`;
                setTimeout(() => {
                    this.$router.push({
                        name: tempTela,
                        params: { id: this.$route.query["id"]},
                        query: { 
                            dadoscadastrais: this.$route.query.dadoscadastrais,
                            politicacomercial: this.$route.query.politicacomercial,
                            analisecomercial: this.$route.query.analisecomercial
                        },
                    });
                }, 1000);
            } else {
                setTimeout(() => {
                    this.$router.push({ name: "ven-tabelapreco-list" });
                }, 1000)
            }
        },
        colorpicked(color) {
            this.tabelaPreco.cor = color;
        },
    },
};
</script>
<style lang="scss" scoped>
.page-container {
    .loading {
        opacity: 0.5;
        pointer-events: none;
        background-color: rgb(255, 0, 0);
    }
}
</style>